import { withStyles } from "@material-ui/core";
import { getLatestBreaks, getZoneValue } from "../../../utils";
import React from "react";
import Details from "./Details";
import DetailsList from "./DetailsList";
import { AccHoursRenderer } from "../../Grid/cellRenderer";
import { formatDateTimeWithoutUTCConversion } from '@dataGrid/gridUtilities';
import { getFormattedValue } from "../utils";
const styles = (theme) => ({
  container: {
    display: "flex",
    border: `1px solid ${theme.AppBGColor}`,
    flexDirection: "row",
    flexGrow: 3,
    padding: "10 12 10 12",
    justifyContent: "space-between",
    flexWrap: "wrap"
  },
  innerContainer: {
    display: "flex",
    flexDirection: "column",
  },
});
const KPIContainer = ({
  classes,
  stopsPerHour,
  delays,
  dispatchZone,
  dailyAccruedHours,
  enableDriverZone,
  weeklyAccruedHours,
  weeklyAllowedHOS,
  dailyAllowedHOS,
  enableWeeklyAccruedHours,
  driverDispatchTime,
  gateOutTime,
  gateInTime,
  enableRestBreakInDelay
}) => {
  const getFeatureBasedManHourValueRenderer = () => {
    const dailyAccruedHourValueRenderer = (
      <AccHoursRenderer
        allowedHOS={dailyAllowedHOS}
        accruedHours={dailyAccruedHours}
      />
    );
    return enableWeeklyAccruedHours
      ? [
          dailyAccruedHourValueRenderer,
          <AccHoursRenderer
            allowedHOS={weeklyAllowedHOS}
            accruedHours={weeklyAccruedHours}
          />,
        ]
      : [dailyAccruedHourValueRenderer];
  };

  const getFeatureBasedManHourLabels = () => {
    const accruedHourLabel = "Acc Hours Daily";
    return enableWeeklyAccruedHours
      ? [accruedHourLabel, "Weekly"]
      : [accruedHourLabel];
  };

  const {latestLunchBreak, latestFuelBreak, latestRestBreak} = getLatestBreaks(delays)

  return (
    <div className={classes.container}>
      <div className={classes.innerContainer}>
        <Details label="Stops per Hr" value={stopsPerHour ?? "NA"} />
        {enableDriverZone > 0 ? (
          <Details
            label="Zones"
            value={getZoneValue({ data: { dispatchZone } })}
          />
        ) : (
          <DetailsList
            labels={getFeatureBasedManHourLabels()}
            values={getFeatureBasedManHourValueRenderer()}
          />
        )}
      </div>
      <div className={classes.innerContainer}>
        <DetailsList
          labels={["Lunch In", "Out"]}
          values={[getFormattedValue(latestLunchBreak?.startTime), getFormattedValue(latestLunchBreak?.endTime)]}
        />
        {enableDriverZone > 0 && (
          <DetailsList
            labels={getFeatureBasedManHourLabels()}
            values={getFeatureBasedManHourValueRenderer()}
          />
        )}
      </div>
      <div className={classes.innerContainer}>
        <DetailsList labels={['Fuel In', 'Out']} values={[getFormattedValue(latestFuelBreak?.startTime), getFormattedValue(latestFuelBreak?.endTime)]} />
        <DetailsList labels={['Gate In', 'Out']} values={[gateInTime, gateOutTime]} />
      </div>
      <div className={classes.innerContainer}>
       {enableRestBreakInDelay ?  <DetailsList labels={['Rest In', 'Out']} values={[getFormattedValue(latestRestBreak?.startTime), getFormattedValue(latestRestBreak?.endTime)]} /> :null }
        <Details
          label="Dispatch Time"
          value={formatDateTimeWithoutUTCConversion({ value: driverDispatchTime })}
        />
      </div>
    </div>
  );
};
export default withStyles(styles)(KPIContainer);
